import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PaginationComponent } from './pagination.component';

@NgModule({
  imports: [CommonModule, MatIconModule, PaginationComponent],
  exports: [PaginationComponent],
})
export class ShimanoPaginationModule {}
